module.exports = __webpack_public_path__ + "img/light-blue-marker.16498b7d.svg";